import * as React from 'react';

import type {
  InviteCompletionDetails,
  InviteEntryPoint,
} from 'bundles/enterprise-admin-learners/components/invite-learners/types';

export type OpenInviteLearnersModalInput = {
  entryPoint: InviteEntryPoint;
  /** Pre-selects (and, with `lockGroupSelection`, fixes) this group — Group Details only. */
  defaultGroupId?: string;
  /** True on Group Details: the group is fixed, not just pre-selected. */
  lockGroupSelection?: boolean;
  /** Refetch/callback fired once invites are sent or an async import is scheduled. */
  onInvited?: (details?: InviteCompletionDetails) => void;
};

/**
 * Imperative surface exposed by {@link InviteLearnersModalProvider} via
 * {@link useInviteLearnersModal}. Kept tiny — consumers only get to open or
 * close the modal; the step-machine state lives inside the modal itself.
 */
export type InviteLearnersModalApi = {
  openModal: (input: OpenInviteLearnersModalInput) => void;
  closeModal: () => void;
};

export const InviteLearnersModalContext = React.createContext<InviteLearnersModalApi | null>(null);
